import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  public title = 'Site en maintenance';
  public subtitle = "Nous travaillons pour améliorer le service. Vous pouvez réessayer plus tard.";
  public contactEmail = 'info@pronatura.com';
  public illustration = 'assets/images/landingPage/maintenance.jpg';

  constructor(private router: Router) {}

  ngOnInit(): void {}

  public goHome(): void {
    //refresh
    window.location.reload();
  }

  public contact(): void {
    window.location.href = `mailto:${this.contactEmail}`;
  }
}
